export default __webpack_public_path__ + "static/media/recorte_15.66f90ed1.JPG";